import { render, staticRenderFns } from "./TransportView.vue?vue&type=template&id=14ba5d98&scoped=true&"
import script from "./TransportView.vue?vue&type=script&lang=ts&"
export * from "./TransportView.vue?vue&type=script&lang=ts&"
import style0 from "./TransportView.vue?vue&type=style&index=0&id=14ba5d98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ba5d98",
  null
  
)

export default component.exports